module.exports = __webpack_public_path__ + "static/media/qrcode.ec803ce0.png";